<template>
	<div class="ecological relative ov">
		<div class="relative box1">
		 <img :src="windowWidth > 820?'https://qiniuimg.wurun.net/b4.jpg':'https://qiniuimg.wurun.net/m_b4.jpg'" alt="">
		 <div class="text">
			<div class="fs45 fw pb30">集团生态</div>
			<div class="fs22 let-spc12" style="margin-right:-12px">一个生态平台服务一家店</div>
			<!-- <p class="ico"></p> -->
			<div class="cor-8f fs10 let-spc6 relative">Weroom Group Ecology</div>
		 </div>
		</div>
		<div class="h2">
			<div>集团生态链旗下子公司</div>
		</div>
		<div class="list flex just-between w1200 relative ">
			<div class="relative flex just-between">
				<div v-for="(d,i) in data" :key="i">
					<div class="img"><img :src="d.url" alt=""></div>
					<div class="fs24 fw mg20 name">{{d.tit}}</div>
					<div class="fs18 cor-27 fw label">{{d.label}}</div>
					<!-- <p class="mt30 mg20"></p> -->
					<div v-if="windowWidth > 820" class="text">{{d.text}}</div>
				</div>
			</div>
			<!-- <img src="@/style/img/w.png" class="eco_bg"> -->
		<svgIcon iconClass="w" class="eco_bg"/>

		</div>
		<!-- <svgIcon iconClass="w" class="eco_bg"/> -->
		<rightTab v-if="windowWidth > 820"/>
	</div>
</template>

<script>
	require('../../style/css_w/ecological.css')
	import rightTab from "@/components/rightTab.vue"
	export default{
		name: 'Ecological',
		components: {
			rightTab
		},
		data () {
			return{
				data:[{
					url:'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/st1.jpg',
					tit:'五润科技开发有限公司',
					label:'科技服务',
					text:'总负责五润生态体系的信息化系统开发，并提供一站式信息化建设服务，以满足五润及其生态产业经营所属的信息化系统支持。'
				},{
					url:'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/st2.jpg',
					tit:'五润品牌策划有限公司',
					label:'品牌营销',
					text:'主要负责五润及其子品牌的品牌定位与理念规划、新品牌策划、品牌形象与视觉设计体系建设，致力于为五润及其机构业务发展进行品牌赋能。'
				},{
					url:'https://qiniuimg.wurun.net/st3.png',
					tit:'五润品牌营运有限公司',
					label:'品牌营运',
					text:'主要针对厦门城市的五润品牌社区店铺拓展及市场营销，建立并践行五润经营理念的标准化营运体系，实现所辖店铺的营运指标。'
				},{
					url:'https://qiniuimg.wurun.net/st4.png',
					tit:'佐籽(厦门)食品有限公司',
					label:'烘焙礼品',
					text:'全面负责“佐籽”品牌的门店和线上商城运营。以茶歇、烘焙、伴手礼等为主营产品与五润及其他品牌的产品线进行有效互补、驱动，满足顾客。'
				},{
					url:'https://qiniuimg.wurun.net/st5.png',
					tit:'五润餐车营运管理有限公司',
					label:'餐车运营',
					text:'主要负责五润餐车项目的营运管理。致力于打造五润城市风景线、树立五润及其他品牌宣传，作为五润口碑营销的民生切入网点。'
				},{
					url:'https://qiniuimg.wurun.net/pc/st10.jpg',
					tit:'五润物流配送有限公司',
					label:'物流配送',
					text:'主要负责五润及其生态产业经营所需的物流配送支持，包括五润到家、五润到店等物流配送业务。'
				},{
					url:'https://qiniuimg.wurun.net/pc/kefu.jpg',
					tit:'五润信息服务有限公司',
					label:'信息服务',
					text:'承接五润生态体系的信息化系统平台运营管理，并提供一站式平台客户服务，以满足五润及其生态产业经营所属的系统平台运营支持。'
				},{
					url:'https://qiniuimg.wurun.net/st8.png',
					tit:'五润（厦门）餐饮管理有限公司',
					label:'中央餐厨',
					text:'主要负责五润集团各品牌的产品研发、生产加工及配料加工服务，满足五润及其他品牌的终端网店销售产品所需的标准化品质供应。'
				},{
					url:'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/st9.jpg',
					tit:'厦门市九香堂贸易有限公司',
					label:'集采贸易',
					text:'全面围绕五润及其生态产业经营所需的供应链配套支持，包含工程装修、集采、贸易、仓储及设备维保的服务支持。'
				},{
					url:'https://qiniuimg.wurun.net/pc/st6.jpg',
					tit:'五润商学传媒有限公司',
					label:'培训/招商',
					text:'主要负责五润及其子品牌项目招商，同时搭建与五润及其生态产业所属公司发展相匹配的培训加赋体系，全面推动五润生态控股平台所属公司体。'
				}],
				windowWidth:'',
			}
		},
		created(){
		},
		mounted(){
			document.documentElement.scrollTop = 0
			this.windowWidth  = document.body.clientWidth
			window.addEventListener('resize', () => this.windowWidth = window.innerWidth, false)
		}
	}
</script>

<style scoped>
	@import url("");
</style>